import React from "react";
import { useState, useEffect } from "react";

import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import classnames from "classnames";
import "./Components.css";
import BoxenAbholen from "./BoxenAbholen";
import CollectDocs from "./CollectDocs";
// import { StatusCodes } from 'http-status-codes';

export default function Sammelliste(props) {
  // const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [okClickTracker, setOkClickTracker] = useState(false);
  const [updateTable, setUpdateTable] = useState(false);
  const [collectedList, setCollectedList] = useState([]);
  const [count, setCount] = useState(1);
  const [disabledButtons, setDisabledButtons] = useState([]);
  const [dropdown, setDropdown] = useState(1000);
  // const arrayOfOrders = [];
  // const arrayOfobjectOFCatDetails = [{}];
  // const [sameOrder, setSameOrder] = useState(false)
  const [textareaValue, setTextareaValue] = useState();
  const [problemInvoiceId, setProblemInvoiceId] = useState(0);
  const [hasProblem, sethasProblem] = useState(false);
  const [multipleorderIds, setMultipleorderIds] = useState([]);

  const [PmodalProblemList, setPmodalProblemList] = useState([]);
  const [problemDetailInvoiceId, setproblemDetailInvoiceId] = useState();
  const [PupdateTriger, setPUpdateTriger] = useState(false);

  // new Array(response.data.records.length).fill(false)

  //start of Modal realated states and function
  const {
    // buttonLabel,
    className,
  } = props;

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [Pmodal, setPModal] = useState(false);
  const toggleP = () => setPModal(!Pmodal);

  //start of AlertModal realated states and function
  const [alertModal, setAlertModal] = useState(false);
  const alertToggle = () => setAlertModal(!alertModal);

  //start of tab realated states and function
  const [activeTab, setActiveTab] = useState(1);
  const tabToggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  //start of dropdown realated states and function
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdowntoggle = () => setDropdownOpen((prevState) => !prevState);
  //end of dropdown realated states and function

  useEffect(() => {
    fetchWatchCollectedApi();
    fetchWatchPhisicallyCollectedApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasProblem, okClickTracker, updateTable, dropdown, PupdateTriger]);

  const okClickHandler = (selectedRow, data) => {
    setOkClickTracker(!okClickTracker);
    if (data.invoiceIdsInOrder.length > 1) {
      // alert("this order has more than 1 item. \n" + " " + "it contains following order ids: \n" + data.invoiceIdsInOrder);
      setMultipleorderIds(data.watchIdsInOrder);
      alertToggle();
    }
    if (count === 1) {
      setDisabledButtons(Array(orders.length).fill(false));
    }
    let cutOut = orders.splice(selectedRow, 1)[0];
    orders.splice(orders.length, 0, cutOut);
    setOrders([...orders]);
    setCount(count + 1);

    const updatedDisabledButtons = [...disabledButtons];
    updatedDisabledButtons[orders.length - count] = true;
    setDisabledButtons(updatedDisabledButtons);

    // for (let i = 0; i < orders.length; i++) {
    //   if ((orders[0].orderId === orders[i])) {
    //     setSameOrder(true)
    //   }
    // }

    const postItem = async (e) => {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/status/${data.invoiceId}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              StatusName: "watchCollected",
              Comment: "a comment goes here",
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setUpdateTable(!updateTable);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    };
    postItem();
  };

  const handleTextareaChange = (event) => {
    setTextareaValue(event.target.value);
  };
  const problemInvoiceIdHandler = (invoiceID) => {
    setProblemInvoiceId(invoiceID);
  };

  const problemHandler = async (e) => {
    // e.preventDefault()
    if (textareaValue !== null) {
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${problemInvoiceId}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              Description: textareaValue,
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          sethasProblem(!hasProblem);
          setTextareaValue(null);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert("Error "+ response.status + "\n" + "request was not successful" + "\n\n" + payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    } 
  };

  const problemsdetailsHandler = (data) => {
    // for (let i = 1; i <= data.problems.length; i++) {
    //      element.push(data.problems[i]);
    //     setmodalProblemList(element)
    // }
    setPmodalProblemList(data.problems);
    setproblemDetailInvoiceId(data.invoiceId);
  };

  const solvePHandler = (problem, problemId, problemDesc, index) => {
    const ProblemSolved = async (e) => {
      // e.preventDefault()
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${problemDetailInvoiceId}/${problemId}`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              solved: true,
              Description: problemDesc,
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          setPUpdateTriger(!PupdateTriger);
          let toRemove = problem;
          let index = PmodalProblemList.indexOf(toRemove);
          // console.log(index);
          if (index > -1) {
            //Make sure item is present in the array, without if condition, -n indexes will be considered from the end of the array.
            PmodalProblemList.splice(index, 1);
            // if (PmodalProblemList.length < 2) {
            //   toggleP()
            // }
          }
          let counterOfProblem = 0;
          PmodalProblemList.forEach(function (arraItem) {
            // Line 87:33:  Expected '===' and instead saw '=='
            if (arraItem.solved === false) {
              ++counterOfProblem;
            }
          });
          if (counterOfProblem < 1) {
            toggleP();
          }
          // console.log(PmodalProblemList);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    };
    ProblemSolved();
  };

  const dropdownHandler = (dropdown) => {
    setDropdown(dropdown);
  };

  // const fetchApiData = async () => {
  //   try {
  //     const response = await fetch('https://cat-fact.herokuapp.com/facts/', {
  //       method: 'get',
  //       headers: new Headers({
  //         'Content-Type': 'application/json',
  //       })
  //     });
  //     const payload = await response.json();
  //     setUsers(payload);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  const fetchWatchCollectedApi = async () => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/watchToCollect/${dropdown}`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setOrders(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const fetchWatchPhisicallyCollectedApi = async () => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/status/watchCollected/${dropdown}`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setCollectedList(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // users.map((cat, index) => {
  //   arrayOfobjectOFCatDetails.push({ "type": cat.type, "text": cat.text, "id": cat._id })
  //   return ''
  // })
  // console.log(arrayOfobjectOFCatDetails)
  return (
    <div className="container customContainer container-fluid">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {/* <h3>{orders.length} Aufträge bereit</h3> */}
        <Badge className="mb-4" variant="info">
          <h1 className="h3">Sammelliste</h1>
        </Badge>
        <div
          className="btnAndNumberContainer"
          style={{ alignItems: "baseline" }}
        >
          <p color="primary">Anzahl angezeigter Aufträge:</p>
          <Dropdown
            isOpen={dropdownOpen}
            toggle={dropdowntoggle}
            className="ml-2"
          >
            <DropdownToggle caret>
              {dropdown === 1000
                ? "Alle"
                : dropdown === 9999
                ? "Alle"
                : dropdown}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem onClick={() => dropdownHandler(20)}>
                20
              </DropdownItem>
              <DropdownItem onClick={() => dropdownHandler(40)}>
                40
              </DropdownItem>
              <DropdownItem onClick={() => dropdownHandler(60)}>
                60
              </DropdownItem>
              <DropdownItem onClick={() => dropdownHandler(80)}>
                80
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={() => dropdownHandler(9999)}>
                Alle{" "}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>

      <div>
        <Nav tabs>
          <NavItem className="onHoverPointer">
            <NavLink
              className={classnames({ active: activeTab === 1 })}
              onClick={() => {
                tabToggle(1);
              }}
              style={
                activeTab === 1
                  ? { backgroundColor: "#007bff", color: "#fff" }
                  : {}
              }
            >
              Uhren abholen
            </NavLink>
          </NavItem>
          <NavItem className="onHoverPointer">
            <NavLink
              className={classnames({ active: activeTab === 2 })}
              onClick={() => {
                tabToggle(2);
              }}
              style={
                activeTab === 2
                  ? { backgroundColor: "#007bff", color: "#fff" }
                  : {}
              }
            >
              Boxen abholen
            </NavLink>
          </NavItem>
          <NavItem className="onHoverPointer">
            <NavLink
              className={classnames({ active: activeTab === 3 })}
              onClick={() => {
                tabToggle(3);
              }}
              style={
                activeTab === 3
                  ? { backgroundColor: "#007bff", color: "#fff" }
                  : {}
              }
            >
              Dokumente abholen
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab} className="mgTop20">
          <TabPane tabId={1}>
            <Row>
              <Col sm="12">
                <div>
                  <p>
                    Noch abzuholen: <strong>{orders.length}</strong> Uhren von{" "}
                    {collectedList.length + orders.length}
                  </p>
                  <Table bordered striped hover>
                    <thead>
                      <tr>
                        <th>Lagerort</th>
                        <th>Digits</th>
                        <th>Auftrag</th>
                        <th>Bezeichnung</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {orders.filter((item, idx) => idx < dropdown).map((data, index) */}
                      {orders.map((data, index) => {
                        // debugger
                        // if (data.items.length > 1) {
                        //   data.items.map((item, index) => {
                        //     arrayOfOrders.push( [data.orderId, item.invoiceId, item.saleTitle])
                        //     return ''
                        //   })
                        // } else {
                        //   arrayOfOrders.push([data.orderId, data.items[0].invoiceId, data.items[0].saleTitle])
                        // }
                        return (
                          <tr
                            key={index}
                            // style={disabledButtons[index] ? { backgroundColor: '#28a745', color: '#fff' } : {}}
                            // className={hasProblem ? "displayNone" : ''}
                          >
                            <th scope="row">{data.locationOfWatch}</th>
                            <td>
                              {data.statusDbDigit}{" "}
                              {data.hasProblem ? (
                                <i
                                  id="problem"
                                  onClick={() => {
                                    toggleP();
                                    problemsdetailsHandler(data);
                                  }}
                                  className="fas fa-exclamation-circle"
                                ></i>
                              ) : (
                                ""
                              )}
                            </td>
                            <td>{data.orderId}</td>
                            <td>{data.saleTitle}</td>
                            <td
                              style={
                                data.invoiceIdsInOrder.length > 1
                                  ? { backgroundColor: "#ffc107" }
                                  : {}
                              }
                            >
                              <div
                                className="displayFlex"
                                style={{ justifyContent: "space-around" }}
                              >
                                <Button
                                  color="primary"
                                  onClick={() => okClickHandler(index, data)}
                                  // disabled={disabledButtons[index]}
                                  // style={disabledButtons[index] ? { cursor: 'not-allowed' } : {}}
                                >
                                  OK
                                </Button>{" "}
                                <div>
                                  <Button
                                    className="ml-3"
                                    //  disabled={disabledButtons[index]}
                                    //   style={disabledButtons[index] ? { cursor: 'not-allowed', marginLeft: '10px' } : { marginLeft: '10px' }}
                                    color="danger"
                                    onClick={() => {
                                      toggle();
                                      setTextareaValue(null);
                                      problemInvoiceIdHandler(data.invoiceId);
                                    }}
                                  >
                                    Problem
                                  </Button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tbody>
                      {collectedList.length > 0 && (
                        <tr className="tbodyDivider">
                          <th colSpan="5">
                            Eingesammelt: {collectedList.length} Uhren
                          </th>
                        </tr>
                      )}
                      {collectedList.map((collecteditem, index) => {
                        return (
                          <tr
                            key={index}
                            style={{
                              backgroundColor: "#00FA9A	",
                              color: "#212529",
                              opacity: "0.8",
                            }}
                          >
                            <th scope="row">{collecteditem.locationOfWatch}</th>
                            <td>
                              {collecteditem.statusDbDigit}{" "}
                              {collecteditem.hasProblem ? (
                                <i
                                  id="problem"
                                  className="fas fa-exclamation-circle"
                                ></i>
                              ) : (
                                ""
                              )}
                            </td>
                            <td>{collecteditem.orderId}</td>
                            <td>{collecteditem.saleTitle}</td>
                            <td
                              style={
                                collecteditem.invoiceIdsInOrder.length > 1
                                  ? { backgroundColor: "#ffc107" }
                                  : {}
                              }
                            ></td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={2}>
            <Row>
              <Col sm="6"></Col>
            </Row>
            <BoxenAbholen
              // users={users}
              dropdown={dropdown}
              watchCollectProblem={hasProblem}
              // disabledButtons={disabledButtons}
              // modal={modal}
              // toggle={toggle}
              // className={className}
              // problemInvoiceIdHandler={problemInvoiceIdHandler}
            />
          </TabPane>
          <TabPane tabId={3}>
            <Row>
              <Col sm="6"></Col>
            </Row>
            <CollectDocs
              // users={orders}
              dropdown={dropdown}
              watchCollectProblem={hasProblem}
              // disabledButtons={disabledButtons}
              // modal={modal}
              // toggle={toggle}
              // className={className}
            />
          </TabPane>
        </TabContent>
      </div>
      <Modal
        size="lg"
        centered={true}
        isOpen={modal}
        toggle={toggle}
        className={className}
      >
        <ModalHeader toggle={toggle}>Problem melden</ModalHeader>
        <ModalBody>
          <textarea
            style={{ width: "100%", height: "100px" }}
            onChange={handleTextareaChange}
          ></textarea>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              problemHandler();
              toggle();
            }}
          >
            Problem speichern
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Abbrechen
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={alertModal}
        centered={true}
        toggle={alertToggle}
        className={className}
      >
        <ModalHeader toggle={alertToggle}>
          Achtung! Auftrag enthält mehrere Uhren.
        </ModalHeader>
        <ModalBody>
          <p>
            Dieser Auftrag beinhaltet mehrere Uhren. Bitte Uhren aus dem Auftrag
            gemeinsam einsortieren.
            <br />
            Interne Nummern in diesem Auftrag:
          </p>
          {
            <ul>
              {multipleorderIds.map((txt, index) => (
                <li key={index}>
                  <b>{txt}</b>
                </li>
              ))}
            </ul>
          }
        </ModalBody>
        <ModalFooter>
          <Button
            color="warning"
            style={{ color: "#212529" }}
            onClick={alertToggle}
          >
            OK
          </Button>{" "}
        </ModalFooter>
      </Modal>

      <Modal
        size="lg"
        centered={true}
        isOpen={Pmodal}
        toggle={toggleP}
        className={className}
      >
        <ModalHeader toggle={toggleP}>Problemdetails</ModalHeader>
        <ModalBody>
          <div>
            <ol
              style={{ maxHeight: "300px", overflow: "auto", paddingLeft: "0" }}
            >
              {PmodalProblemList.map((problem, index) => {
                if (!problem.solved) {
                  return (
                    <div
                      key={index}
                      // style={ (solvedClicked && solvedClickedIndex === index) ? { display: "none"} : {}}
                    >
                      <li
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          justifyContent: "space-between",
                          marginRight: "10px",
                        }}
                      >
                        <p>
                          <span style={{ paddingRight: "16px" }}>
                            <b>{problem.personName}:</b>
                          </span>
                          {problem.description}
                        </p>
                        {/* {modalProblemList} */}
                        <Button
                          color="success"
                          className="ml-3"
                          onClick={() => {
                            solvePHandler(
                              problem,
                              problem.id,
                              problem.description,
                              index
                            );
                          }}
                        >
                          Problem gelöst
                        </Button>
                      </li>
                      <hr></hr>
                    </div>
                  );
                }
                return null;
              })}
            </ol>
          </div>
          {/* <textarea style={{ width: '100%', height: '100px' }} placeholder="In case of new problem, please write your comment here"
                        onChange={handleProblemTextareaChange}
                        autoFocus={true} ></textarea> */}
        </ModalBody>
        {/* <ModalFooter style={{ justifyContent: "space-between" }}>
                    <Button color="primary" onClick={() => { updateProblemHandler(); toggleP() }}>Update the problem</Button>{' '}
                    <Button color="danger" onClick={() => {cancelHandler(); toggleP();}}>Cancel item</Button>
                    <Button color="secondary" onClick={toggleP}>Close</Button>
                </ModalFooter> */}
      </Modal>
      {/* {console.log(orders)} */}
    </div>
  );
}
